var map = {
	"./en.svg": "7534",
	"./france.svg": "08bb",
	"./germany.svg": "aac1",
	"./japan.svg": "1418",
	"./spain.svg": "b773",
	"./tr.svg": "6919",
	"./uk.svg": "b5c9",
	"./united-states.svg": "91ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1da8";